module.exports = "/assets/data/70f76ee04b2dbf369ed41afa0e9087c0-ME4.data.json";